import { ChevronUp, RotateCcw, Trash2 } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Select, message, Button, Modal } from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from "ag-grid-community";
import { fetchBrandsBySelectedClients } from "../../core/api/settings";
import {
  getAllReports,
  getMailingResponseDataByFileId,
  deleteReport,
} from "../../core/api/report";
import UploadReport from "../Reports/uploadreport";
import { getCurrentUser } from "../../core/api/settings";
import { getProfileTest } from "../../core/api/auth.js";


ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: "legacy" });

const MailingResponseLTV = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const selectedClients = useSelector((state) => state.selectedClients);
  const profile = useSelector((state) => state.profile); 
  console.log("Profile in MailingResponseLTV component:",profile);

  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [loadingBrands, setLoadingBrands] = useState(false);

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allUploadedFiles, setAllUploadedFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);
  const [isUploadViewVisible, setIsUploadViewVisible] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const [previewReportId, setPreviewReportId] = useState(null);


  const handleUploadFile = () => {
    if (selectedClients.length !== 1 || selectedClients[0] === "all") {
      message.warning("Please select exactly one client.");
      return;
    }
    setIsUploadViewVisible(true);
  };

  // ** Function to fetch MailingResponseData when a file is selected **
  const fetchMailingResponseData = async (fileId) => {
    if (!fileId) return;
    setLoading(true);
    try {
      const res = await getMailingResponseDataByFileId(fileId);
      if (!res.data || res.data.length === 0) {
        message.warning("No data found for this file.");
        setRowData([]);
      } else {
        setRowData(res.data);
      }
    } catch (error) {
      message.error("Failed to fetch mailing response data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedClients.length !== 1 || selectedClients[0] === "all") return;
    const fetchDropdownData = async () => {
      if (selectedClients.length === 1 && selectedClients[0] !== "all") {
        try {
          const filesRes = await getAllReports({
            client_ids: selectedClients.length ? selectedClients : [],
            brand_ids: selectedBrand ? [selectedBrand] : [],
          });

          const formattedFiles = filesRes.data?.map((file) => ({
            value: file.id,
            label:
              "Uploaded on " +
              new Date(file.created_at).toDateString() +
              " at " +
              new Date(file.created_at).toLocaleTimeString(),
          }));

          setAllUploadedFiles(formattedFiles);

          if (formattedFiles.length > 0 && firstLoad) {
            const latestFile = formattedFiles[0];
            setSelectedFile(latestFile.value);
            fetchMailingResponseData(latestFile.value);
            setFirstLoad(false);
          }
        } catch (error) {
          console.error("Error fetching processed data:", error);
        }
      } else {
        message.warning("Please select one client");
        setAllUploadedFiles([]);
      }
    };
    fetchDropdownData();
  }, [selectedClients, selectedBrand, firstLoad]);

  useEffect(() => {
    setBrands([]);
    setSelectedBrand(null);
    fetchBrandsBySelectedClients(selectedClients)
      .then((res) => {
        if (!res.data || res.data.length === 0) return;
        setBrands(res.data);
        if (res.data.length === 1) {
          setSelectedBrand(res.data[0].id);
        }
        setLoadingBrands(false);
      })
      .catch(() => {
        setLoadingBrands(false);
        message.error("Failed to fetch brands.");
      });
  }, [selectedClients]);

   useEffect(() => {
      const fetchPermissions = async () => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
        if (token) {
          try {
            sessionStorage.setItem("page_authorization", JSON.stringify(profile?.page_authorization));
            sessionStorage.setItem("user_role", profile?.role);
            // Set other session keys as needed
          } catch (e) {
            console.error("Failed to fetch permissions", e);
          }
        }
      };
      fetchPermissions();
      }, [profile]);

    const pageAuthorizations = sessionStorage.getItem("page_authorization") || "";
    const userRole = sessionStorage.getItem("user_role");

    
    const canAddmailing = userRole === "admin" || userRole === "super_admin" || pageAuthorizations.includes("/mailing-response-ltv-data_create*");
    const canEditmailing = userRole === "admin" || userRole === "super_admin" || pageAuthorizations.includes("/mailing-response-ltv-data_edit*");
    const canDeletemailing = userRole === "admin" || userRole === "super_admin" || pageAuthorizations.includes("/mailing-response-ltv-data_delete*");
    const canDownloadmailing = userRole === "admin" || userRole === "super_admin" || pageAuthorizations.includes("/mailing-response-ltv-data_download*");
  


  const handleFileSelection = (file) => {
    setSelectedFile(file);
    fetchMailingResponseData(file);
  };
  
  // Function to handle file deletion
  const handleDeleteFile = (fileId) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this file?',
      content: 'This action cannot be undone.',
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await deleteReport(fileId);
          message.success('File deleted successfully');
          // Remove the deleted file from the dropdown
          setAllUploadedFiles(allUploadedFiles.filter(file => file.value !== fileId));
          // If the deleted file was selected, clear the selection and data
          if (selectedFile === fileId) {
            setSelectedFile(null);
            setRowData([]);
          }
        } catch (error) {
          message.error('Failed to delete file');
          console.error('Error deleting file:', error);
        }
      },
    });
  };

  const columns = useMemo(() => {
    if (rowData.length === 0) return [];
    return Object.keys(rowData[0])
      .filter((key) => !["id", "report_file"].includes(key))
      .map((key) => ({
        headerName: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        field: key,
        sortable: true,
        filter: true,
        resizable: true,
      }));
  }, [rowData]);
 
  

   // Permission check
  
  return (
    <div className="">
      <div className="">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Mailing Response & LTV</h4>
            </div>
          </div>

          <ul className="table-top-head">
            <li>
              <Select
                placeholder="Select Brand"
                options={brands.map((brand) => ({
                  value: brand.id,
                  label: brand.brand_name,
                }))}
                onChange={(values) => setSelectedBrand(values)}
                value={selectedBrand}
                loading={loadingBrands}
              />
            </li>
            <li>
              <Select
                style={{ width: 400 }}
                className="me-2"
                placeholder="Select from Existing files to Process"
                allowClear
                value={selectedFile}
                onChange={(v) => handleFileSelection(v)}
                options={allUploadedFiles.map((file) => ({
                  value: file.value,
                  label: (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>{file.label}</span>
                      <Trash2 
                        size={16} 
                        color="#ff4d4f" 
                        style={{ cursor: 'pointer' }} 
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteFile(file.value);
                        }}
                      />
                    </div>
                  ),
                }))}
                optionRender={(option) => option.label}
              />
            </li>
            {canDownloadmailing && (
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Print</Tooltip>}
              >
                <Link
                  onClick={() => {
                    // intentionally empty
                  }}
                >
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
               )}
          {canDownloadmailing && (
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Excel</Tooltip>}
              >
                <Link
                  onClick={() => {
                    // intentionally empty
                  }}
                >
                  <ImageWithBasePath src="assets/img/icons/xls.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
          )}
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Refresh</Tooltip>}
              >
                <Link onClick={() => fetchMailingResponseData(selectedFile)}>
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Collapse</Tooltip>}
              >
                <Link
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <Button
                type="primary"
                className="btn btn-primary"
                onClick={handleUploadFile}
                icon={<PlusCircle className="me-0 iconsize" />}
              >
                Upload New File
              </Button>
            </li>
          </ul>
        </div>

        <div className="card table-list-card">
          <div
            className="ag-theme-quartz"
            style={{ height: "700px", width: "100%" }}
          >
            <AgGridReact
              columnDefs={columns}
              rowData={rowData}
              defaultColDef={{ flex: 1, minWidth: 100 }}
              pagination={false}
              loading={loading}
            />
          </div>
        </div>
      </div>
      <UploadReport
        isVisible={isUploadViewVisible}
        onClose={() => {
          setIsUploadViewVisible(false);
          setPreviewReportId(null);
        }}
        onResize={setSidebarWidth}
        fetchFiles={() => {
          // intentionally empty
        }}
        clientId={selectedClients[0]}
        reportId={previewReportId}
      />
    </div>
  );
};

export default MailingResponseLTV;
